import React from 'react';
import s from './Main.module.scss';
import {TabBar} from "components/TabBar/TabBar";
import {Route, Routes} from "react-router-dom";
import {Dashboard} from "../Dashboard/Dashboard";
import {Permissions} from "utils/permissions";
import {Language} from "../Language/Language";
import {Pages} from "../Pages/Pages";
import {useGetModulesQuery} from "../../redux/apis/modulesApi";
import {Module} from "../Module/Module";
import {Category} from "../Category/Category";
import {Delivery} from "../Delivery/Delivery";
import {Products} from "../Products/Products";
import {Blog} from "../Blog/Blog";
import {Storage} from "../Storage/Storage";
import {Documents} from "../Documents/Documents";
import { Administrators } from 'pages/Administrators/Administrators';
import { MailingsPage } from 'pages/Mailing/MailingsPage';
import { useGetLangsQuery } from '../../redux/apis/langApi';
import { CoursesPage } from 'pages/CoursesPage/CoursesPage';
import { CreateBlog } from 'pages/Blog/CreateBlog/CreateBlog';
import { ModalsPage } from 'pages/ModalsPage/ModalsPage';
import { Support } from 'pages/Support/Support';
import { Chat } from 'pages/Support/components/Chat/Chat';
import { SupportSettings } from 'pages/Support/components/SupportSettings/SupportSettings';
import { CreateDefaultMessage } from 'pages/Support/components/SupportSettings/CreateMessage/CreateDefaultMessage';

export const Main = () => {
    const { data: modules} = useGetModulesQuery({});
    const {isLoading} = useGetLangsQuery({})
    if(isLoading) return <></>
    const routes_view = modules?.modules?.map((el: any) => {
        return (
            <Route
                key={el.id}
                path={`/module/${el.id}`}
                element={
                    <Permissions page="modules" type="view">
                        <Module id={el.id} title={el.name}/>
                    </Permissions>
                }
            />
        )
    })

    return (
        <div className={s.main}>
            <div className={s.sidebar}>
                <TabBar />
            </div>
            <section className={s.main_content}>
                <Routes>
                    <Route path="*" element={<Dashboard />} />
                    <Route path="/dashboard/*" element={<Dashboard />} />
                    <Route path="/administrators" element={<Administrators />} />
                    <Route path="/category" element={<Category />} />
                    <Route path="/delivery" element={<Delivery />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/language" element={<Permissions page="langs" type="view"><Language /></Permissions>}/>
                    <Route path="/pages" element={<Permissions page="pages" type="view"><Pages /></Permissions>}/>
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/create" element={<CreateBlog />} />
                    <Route path="/storage" element={<Storage />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/mailings/*" element={<MailingsPage />} />
                    <Route path="/courses/*" element={<CoursesPage />} />
                    <Route path="/modals/*" element={<ModalsPage />} />
                    <Route path="/support/*" element={<Support />} />
                    <Route path="/support/chat/:chat" element={<Chat />} />
                    

                    <Route
                        path={`/module`}
                        element={
                            <Permissions page="modules" type="view">
                                <Module title={"No title"}/>
                            </Permissions>
                        }
                    />
                    {routes_view}
                </Routes>
            </section>
        </div>
    )
}